import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data?.data?.data
  return respData?.map((item) => {
    const gst = (Number(item?.monthlyCharges) * 0.152542).toFixed(2)
    const monthlyCharge = (Number(item?.monthlyCharges) - Number(gst)).toFixed(2)
    return {
      id: item?.invoiceNumber ?? 'NA',
      title: item?.billingMonth ?? 'Invoice',
      duration: item?.billingCycle ?? 'NA',
      txnId: item?.transactionId ?? 'NA',
      totalCharges: item?.monthlyCharges ?? 'NA',
      status: item?.transactionStatus ?? 'NA',
      tid: item?.tid ?? 'NA',
      mid: item?.mid ?? 'NA',
      dsn: item?.deviceLinkId ?? 'NA',
      vpa: item?.vpa ?? 'NA',
      paidOn: item?.invoiceDate ?? 'NA',
      monthlyCharges: monthlyCharge ?? 'NA',
      gst: gst ?? 'NA',
    }
  })
}

const getVoiceBoxInvoices = (tokens: any, req: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: `${APIEndPoints.voiceboxInvoices}`,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { getVoiceBoxInvoices }
